@file:OptIn(InternalResourceApi::class)

package waifupics.modules.features.random.image.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/waifupics.modules.features.random.image.generated.resources/"

@delegate:ResourceContentHash(1_777_727_918)
internal val Res.drawable.ic_bookmark: DrawableResource by lazy {
      DrawableResource("drawable:ic_bookmark", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bookmark.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(96_791_217)
internal val Res.drawable.ic_bookmark_solid: DrawableResource by lazy {
      DrawableResource("drawable:ic_bookmark_solid", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bookmark_solid.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_922_079_734)
internal val Res.drawable.ic_filter: DrawableResource by lazy {
      DrawableResource("drawable:ic_filter", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_filter.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(327_362_526)
internal val Res.drawable.ic_flag: DrawableResource by lazy {
      DrawableResource("drawable:ic_flag", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_flag.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_589_009_142)
internal val Res.drawable.ic_heart: DrawableResource by lazy {
      DrawableResource("drawable:ic_heart", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_heart.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_679_967_317)
internal val Res.drawable.ic_heart_solid: DrawableResource by lazy {
      DrawableResource("drawable:ic_heart_solid", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_heart_solid.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(577_421_197)
internal val Res.drawable.ic_refresh: DrawableResource by lazy {
      DrawableResource("drawable:ic_refresh", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_refresh.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_354_270_011)
internal val Res.drawable.ic_rotate: DrawableResource by lazy {
      DrawableResource("drawable:ic_rotate", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_rotate.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_825_548_515)
internal val Res.drawable.ic_share: DrawableResource by lazy {
      DrawableResource("drawable:ic_share", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_share.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(884_131_775)
internal val Res.drawable.senpai: DrawableResource by lazy {
      DrawableResource("drawable:senpai", setOf(
        ResourceItem(setOf(), "${MD}drawable/senpai.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_bookmark", Res.drawable.ic_bookmark)
  map.put("ic_bookmark_solid", Res.drawable.ic_bookmark_solid)
  map.put("ic_filter", Res.drawable.ic_filter)
  map.put("ic_flag", Res.drawable.ic_flag)
  map.put("ic_heart", Res.drawable.ic_heart)
  map.put("ic_heart_solid", Res.drawable.ic_heart_solid)
  map.put("ic_refresh", Res.drawable.ic_refresh)
  map.put("ic_rotate", Res.drawable.ic_rotate)
  map.put("ic_share", Res.drawable.ic_share)
  map.put("senpai", Res.drawable.senpai)
}
